import jsPDF from "jspdf";
import logoGente from "../../../src/imagens/20191205 - Logo GENTE.png";
import logoPrefeitura from "../../../src/imagens/prefeitura_ouro_preto_logo_1.png";
import Api from "../../services/Api";

class PdfAmbiental {
  static async gerarRelatorio(
    distrito,
    nascentes,
    aguaCorrente,
    mata,
    agrotoxico,
    problemaSaudeAgrotoxico,
    ambientalMapImage,
    nascentesImage,
    aguaCorrenteImage,
    mataImage,
    agrotoxicoImage,
    problemaSaudeAgrotoxicoImage,
    tipoMataImage
  ) {
    const [
      propriedades,
      areaMedia,
      nascentesValue,
      nascentesData,
      aguaCorrenteData,
      mataData,
      agrotoxicoData,
      problemaSaudeAgrotoxicoData,
      tipoMataData,
    ] = await Promise.all([
      Api.getNumeroPropriedadesAmbiental(
        distrito,
        nascentes,
        aguaCorrente,
        mata,
        agrotoxico,
        problemaSaudeAgrotoxico,
      ),
      Api.getAreaMediaAmbiental(
        distrito,
        nascentes,
        aguaCorrente,
        mata,
        agrotoxico,
        problemaSaudeAgrotoxico,
      ),
      Api.getNumeroNascentes(
        distrito,
        nascentes,
        aguaCorrente,
        mata,
        agrotoxico,
        problemaSaudeAgrotoxico,
      ),
      Api.getNascentes(
        distrito,
        null,
        aguaCorrente,
        mata,
        agrotoxico,
        problemaSaudeAgrotoxico,
      ),
      Api.getAguaCorrente(
        distrito,
        nascentes,
        null,
        mata,
        agrotoxico,
        problemaSaudeAgrotoxico,
      ),
      Api.getMata(
        distrito,
        nascentes,
        aguaCorrente,
        null,
        agrotoxico,
        problemaSaudeAgrotoxico,
      ),
      Api.getAgrotoxico(
        distrito,
        nascentes,
        aguaCorrente,
        mata,
        null,
        problemaSaudeAgrotoxico,
      ),
      Api.getProblemasSaudeAgrotoxico(
        distrito,
        nascentes,
        aguaCorrente,
        mata,
        agrotoxico,
        null,
      ),
      Api.getTipoMata(
        distrito,
        nascentes,
        aguaCorrente,
        mata,
        agrotoxico,
        problemaSaudeAgrotoxico,
      ),
    ]);

    const doc = new jsPDF();
    const imgSize = 64;

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageOne(
      doc,
      distrito,
      propriedades.value,
      areaMedia.value,
      nascentesValue.value,
      nascentes,
      aguaCorrente,
      mata,
      agrotoxico,
      problemaSaudeAgrotoxico,
      ambientalMapImage,
    );

    doc.addPage();

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageTwo(
      doc,
      propriedades.value,
      nascentesData.value,
      aguaCorrenteData.value,
      mataData.value,
      nascentesImage,
      aguaCorrenteImage,
      mataImage,
      imgSize,
    );

    doc.addPage();

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageThree(
      doc,
      propriedades.value,
      agrotoxicoData.value,
      problemaSaudeAgrotoxicoData.value,
      tipoMataData.value,
      agrotoxicoImage,
      problemaSaudeAgrotoxicoImage,
      tipoMataImage,
      imgSize,
    );

    const fileName =
      "Relatorio_Ambiental_" + distrito + "_" + this.dataAtual() + ".pdf";
    doc.save(fileName);
  }

  static pageOne(
    doc,
    distrito,
    propriedades,
    areaMedia,
    nascentesValue,
    nascentes,
    aguaCorrente,
    mata,
    agrotoxico,
    problemaSaudeAgrotoxico,
    ambientalMapImage,
  ) {
    // Considerações Iniciais
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("Considerações iniciais", 10, 40);
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    const consideracoes = `      As informações e dados contidas no presente relatório foram extraídas através do dashboard oficial do Censo Agropecuário de Ouro Preto – MG. O Censo Agropecuário foi uma das principais etapas do Plano Municipal de Desenvolvimento Rural de Ouro Preto, projeto desenvolvido pela Secretaria Municipal de Agropecuária em parceria com a Universidade Federal de Viçosa. O objetivo central do Censo Agropecuário consistiu na busca de informações sobre os estabelecimentos e as atividades agropecuárias, caracterizando o produtor e o estabelecimento, a economia e emprego no meio rural, a pecuária, a lavoura e a agroindústria. Todo o processo foi realizado a partir da aplicação do Boletim de Cadastro Rural (BCR), formulário estruturado para caracterizar as propriedades, a infraestrutura rural, as condições socioeconômicas dos produtores e as atividades desenvolvidas. A seguir serão sintetizados alguns dados do Censo Agropecuário em formas de tabelas, gráficos e mapas.`;
    doc.text(consideracoes, 10, 50, { maxWidth: 180, align: "justify" });

    // Lista de condições e filtros
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Lista de condições e filtros aplicados", 10, 110);

    let y = 120;
    const filtros = [
      ["Distrito:", distrito || "Não informado"],
      ["Nascentes:", nascentes || "Não informado"],
      ["Água corrente:", aguaCorrente || "Não informado"],
      ["Mata:", mata || "Não informado"],
      ["Agrotóxico:", agrotoxico || "Não informado"],
      [
        "Problema de saúde causado por agrotóxico:",
        problemaSaudeAgrotoxico || "Não informado",
      ],
    ];

    doc.setFontSize(12);

    filtros.forEach(([label, valor]) => {
      // Marcador
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      // Label em negrito
      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 10, y);

      y += 6;
    });

    y += 5;
    // Indicadores
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Informações Gerais", 10, y);
    y += 10;

    const indicadores = [
      ["Propriedades:   ", propriedades],
      ["Área média:   ", areaMedia.toFixed(2)],
      ["Número de nascentes:   ", nascentesValue],
    ];

    doc.setFontSize(12);

    indicadores.forEach(([label, valor]) => {
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 2, y);

      y += 6;
    });

    y += 5;

    doc.addImage(ambientalMapImage, "PNG", 20, y, 100, 80); // aumenta um pouco pra ver
  }

  static pageTwo(
    doc,
    propriedades,
    nascentesData,
    aguaCorrenteData,
    mataData,
    nascentesImage,
    aguaCorrenteImage,
    mataImage,
    imgSize,
  ) {
    let y = 40;

    doc.addImage(
      nascentesImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `     Observa-se que ${this.calcPercentual(nascentesData["01 - Não"], propriedades)}% dos entrevistados declararam não possuir nascentes em suas propriedades, enquanto ${this.calcPercentual(nascentesData["02 - Sim"], propriedades)}% afirmaram possuir nascentes.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );

    doc.addImage(
      aguaCorrenteImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `     Verifica-se que ${this.calcPercentual(aguaCorrenteData["01 - Não"], propriedades)}% dos participantes informaram ter água corrente, enquanto ${this.calcPercentual(aguaCorrenteData["01 - Não"], propriedades)}% declararam não possuir esse recurso hídrico.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );

    doc.addImage(
      mataImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `     Constata-se que ${this.calcPercentual(mataData["01 - Não"], propriedades)}% dos respondentes afirmaram possuir mata na propriedade, ao passo que ${this.calcPercentual(mataData["01 - Não"], propriedades)}% relataram não possuir.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );
  }

  static pageThree(
    doc,
    propriedades,
    agrotoxicoData,
    problemaSaudeAgrotoxicoData,
    tipoMataData,
    agrotoxicoImage,
    problemaSaudeAgrotoxicoImage,
    tipoMataImage,
    imgSize,
  ) {
    let y = 40;

    doc.addImage(
      agrotoxicoImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      Nota-se que ${this.calcPercentual(agrotoxicoData["01 - Não"], propriedades)}% dos entrevistados declararam não utilizar agrotóxicos, enquanto ${this.calcPercentual(agrotoxicoData["02 - Sim"], propriedades)}% afirmaram fazer uso desses produtos.  `,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );

    y += 5;

    doc.addImage(
      problemaSaudeAgrotoxicoImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      Verifica-se que ${this.calcPercentual(problemaSaudeAgrotoxicoData["02 - Sim"], propriedades)}% dos participantes relataram ter problemas de saúde decorrentes do uso de agrotóxico, enquanto ${this.calcPercentual(problemaSaudeAgrotoxicoData["01 - Não"], propriedades)}% declaram não ter problemas e ${this.calcPercentual(problemaSaudeAgrotoxicoData["Não Informado"], propriedades)}% não informaram.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );

    y += 5;

    doc.addImage(
      tipoMataImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      Identifica-se que ${tipoMataData["01 - Mata Fechada"]} propriedades possuem mata, ${tipoMataData["Não Informado"]} não informaram o tipo de mata, ${tipoMataData["02 - Capoeira"]} declararam possuir capoeira, ${tipoMataData["03 - Mata Ciliar"]} possuem mata ciliar, ${tipoMataData["05 - Outras"]} indicaram outras formas de mata e ${tipoMataData["04 - Cerrado"]} relataram cerrado.`,      10,
      y,
      { maxWidth: 180, align: "justify" },
    );
  }

  static calcPercentual(val, total) {
    const res = (val / total) * 100;
    return res.toFixed(2);
  }

  static gerarCabecalho(doc, logoEsq, logoDir) {
    // Logo à esquerda
    if (logoEsq) {
      doc.addImage(logoEsq, "PNG", 10, 10, 30, 20);
    }

    // Logo à direita
    if (logoDir) {
      doc.addImage(logoDir, "PNG", 170, 10, 30, 15);
    }

    // Título central
    doc.setFontSize(14);
    doc.text(
      "Relatório de características ambientais ",
      doc.internal.pageSize.getWidth() / 2,
      15,
      { align: "center" },
    );
    doc.text(
      "e agrotóxicos das propriedades rurais",
      doc.internal.pageSize.getWidth() / 2,
      21,
      { align: "center" },
    );
    doc.text(
      "cadastradas no censo agropecuário",
      doc.internal.pageSize.getWidth() / 2,
      27,
      { align: "center" },
    );

    // Informações extras
    doc.setFontSize(8);
    doc.text(`Data: ${new Date().toLocaleDateString()}`, 170, 28);

    // Linha divisória
    doc.setDrawColor(150);
    doc.line(10, 32, 200, 32);
  }

  static dataAtual() {
    const hoje = new Date();

    const data = hoje.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const formatada = data.replace(/\//g, "_");

    return formatada;
  }
}

export default PdfAmbiental;
